<div class="loading">
  <div fxLayout="row wrap" class="bottom-spacer">
    <div
      class="loading-item"
      fxFlex.gt-500="{{ total === 1 ? 100 : 49 }}%"
      fxFlex.gt-1200="{{ total < 4 ? 100 / total - 1 : 23.5 }}%"
      *ngFor="let card of cards"
    >
      <div
        class="loading-box"
        [ngClass]="{ tall: type === 'table', short: type === 'card' }"
      ></div>
    </div>
  </div>
</div>
